export default __webpack_public_path__ + "img/6e9956c3002dadba69d16b10c77b20b5.png";